import { httpClient } from '@shared/js/api/httpClient';
import { normalizeCheckoutQuoteResponse } from '@shared/js/payments/checkoutQuoteFormat';

export default {
	data() {
		return {
			checkoutQuote:          null,
			checkoutQuoteKey:       null,
			checkoutQuoteRequestId: 0,
			isCheckoutQuoteLoading: false,
		};
	},
	computed: {
		checkoutQuoteWatchKey() {
			const offerId = this.offer?.id ?? '';
			const eventId = this.checkoutQuoteEventId ?? '';
			const voucherId = this.checkoutQuoteVoucherId ?? '';
			const loggedIn = this.isLoggedIn === false ? '0' : '1';

			return `${loggedIn}-${offerId}-${eventId}-${voucherId}`;
		},
		currentCheckoutQuote() {
			return this.checkoutQuoteKey === this.checkoutQuoteWatchKey ? this.checkoutQuote : null;
		},
		checkoutQuoteEventId() {
			return null;
		},
		checkoutQuoteVoucherId() {
			return null;
		},
	},
	watch: {
		checkoutQuoteWatchKey: {
			handler() {
				this.loadCheckoutQuote();
			},
			immediate: true,
		},
	},
	methods: {
		// Load the quote for the current selection without allowing older requests to overwrite it.
		async loadCheckoutQuote() {
			const requestId = ++this.checkoutQuoteRequestId;
			const requestKey = this.checkoutQuoteWatchKey;
			this.checkoutQuote = null;
			this.checkoutQuoteKey = null;

			if (!this.offer?.id || this.isLoggedIn === false) {
				this.isCheckoutQuoteLoading = false;
				return;
			}

			this.isCheckoutQuoteLoading = true;
			const offerId = this.offer.id;
			const eventId = this.checkoutQuoteEventId;
			const voucherId = this.checkoutQuoteVoucherId;

			try {
				const response = await httpClient.getPaymentCheckoutQuote({
					offerId,
					eventId,
					voucherId,
				});
				if (requestId !== this.checkoutQuoteRequestId || requestKey !== this.checkoutQuoteWatchKey) {
					return;
				}
				this.checkoutQuote = normalizeCheckoutQuoteResponse(response?.data);
				this.checkoutQuoteKey = requestKey;
			} catch (error) {
				if (requestId !== this.checkoutQuoteRequestId || requestKey !== this.checkoutQuoteWatchKey) {
					return;
				}
				console.error('checkoutQuoteMixin - failed to load checkout quote', error);
				this.checkoutQuote = null;
				this.checkoutQuoteKey = null;
			} finally {
				if (requestId === this.checkoutQuoteRequestId) {
					this.isCheckoutQuoteLoading = false;
				}
			}
		},
	},
};
